import TableExport from 'tableexport'

const URL_REVOKE_DELAY = 60000
const UTF8_BOM = '\uFEFF'
const SUPPORTED_FORMATS = ['xlsx', 'csv']

const createFile = (table, filename, format) => {
  if (!table) {
    throw new Error('Report table is not available')
  }

  if (SUPPORTED_FORMATS.indexOf(format) === -1) {
    throw new Error('Report format ' + format + ' is not supported')
  }

  const exporter = TableExport(table, {
    headers: true,
    footers: true,
    formats: [format],
    filename,
    bootstrap: false,
    exportButtons: false,
    ignoreRows: null,
    ignoreCols: null,
    trimWhitespace: true
  })

  try {
    const tableData = exporter.getExportData()[table.id]
    const fileData = tableData && tableData[format]

    if (!fileData) {
      throw new Error('Report data is not available')
    }

    const data = exporter.getRawData(
      fileData.data,
      fileData.fileExtension,
      fileData.filename,
      fileData.merges,
      fileData.RTL,
      fileData.sheetname
    )

    return {
      blob: new Blob([format === 'csv' ? UTF8_BOM + data : data], { type: fileData.mimeType }),
      filename: fileData.filename + fileData.fileExtension
    }
  } finally {
    exporter.remove()
  }
}

const downloadBlob = (blob, filename) => {
  const urlApi = window.URL || window.webkitURL
  const url = urlApi.createObjectURL(blob)
  const link = document.createElement('a')

  link.href = url
  link.download = filename
  link.style.display = 'none'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.setTimeout(() => urlApi.revokeObjectURL(url), URL_REVOKE_DELAY)
}

export const downloadTable = (table, filename, format = 'xlsx') => {
  const file = createFile(table, filename, format)
  downloadBlob(file.blob, file.filename)
}



// WEBPACK FOOTER //
// ./src/helpers/report-export.js